import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { InvestmentOpportunityListPresenter } from './investment-opportunity-list-presenter'
import { investmentServices, investorServices, kycServices } from '../../services'
import { InvestorInvestmentSearchParams } from '../../lib/types'

function InvestmentOpportunityListContainer() {
  const { investorId } = useParams()
  const [user, setUser] = useState()
  const [investments, setInvestments] = useState([])
  const [searchParams, setSearchParams] = useState<InvestorInvestmentSearchParams>({
    limit: '10',
    offset: '0',
    investor_id: investorId,
    investor_portfolio_id: '',
  })
  const [pagination, setPagination] = useState({
    total: 0,
    limit: 10,
    count: 5,
    offset: 0,
  })
  const [currentPage, setCurrentPage] = useState(1)
  const [investorPortfolioIds, setInvestorPortfolioIds] = useState<string[]>([])

  useEffect(() => {
    if (investorId) {
      investorServices.getInvestorProfile(parseInt(investorId)).then((response: any) => {
        if (response) {
          setUser(response)
        }
      })

      kycServices.getInvestorPortfolioIds(investorId).then((response: any) => {
        if (response) {
          const portfolioIds = response.data.map((item: any) => ({
            value: item.investor_portfolio_id,
            text: item.investor_portfolio_id,
          }))
          setInvestorPortfolioIds([{ text: 'All', value: 'All' }, ...portfolioIds])
          setSearchParams((oldState) => ({
            ...oldState,
            investor_portfolio_id: portfolioIds?.[0]?.value ?? 'All',
          }))
        }
      })
    }
  }, [investorId])

  useEffect(() => {
    const fetchAllInvestments = async () => {
      const data = await investmentServices.getInvestments({
        ...searchParams,
        investor_portfolio_id:
          searchParams.investor_portfolio_id === 'All' ? '' : searchParams.investor_portfolio_id,
      })
      if (data.status === 200) {
        setInvestments(data.investments)
        setPagination(data.pagination)
      }
    }
    fetchAllInvestments()
  }, [currentPage, searchParams])

  const handleSearchParams = async ({ name, value }: { name: string; value: string }) => {
    const { limit } = pagination
    setSearchParams({
      ...searchParams,
      offset: '0',
      limit: limit.toString(),
      [name]: value,
    })
    setCurrentPage(1)
    setPagination({ ...pagination, offset: 0 })
  }

  const resetSearchParams = async () => {
    setSearchParams({
      limit: '10',
      offset: '0',
      keyword: '',
      filterBy: '',
      sortBy: '',
      investor_id: investorId,
    })
  }

  const handleCurrentPage = (currentPage: number) => {
    const { limit } = pagination
    setCurrentPage(currentPage)
    setSearchParams({
      ...searchParams,
      offset: `${(currentPage - 1) * limit}`,
    })
    setPagination({ ...pagination, offset: (currentPage - 1) * limit })
  }

  return (
    <InvestmentOpportunityListPresenter
      user={user}
      pagination={pagination}
      handleCurrentPage={handleCurrentPage}
      setCurrentPage={setCurrentPage}
      currentPage={currentPage}
      resetSearchParams={resetSearchParams}
      searchParams={searchParams}
      handleSearchParams={handleSearchParams}
      investments={investments}
      investorPortfolioIds={investorPortfolioIds}
    />
  )
}

export { InvestmentOpportunityListContainer }
